import React from 'react'
import {AccountSection} from './account'
import {AuthenticationSection} from './authentication'
import {Router} from '@reach/router'

const ReferenceSection = () => {
  return (
    <Router>
      <AuthenticationSection path='authentication/*'/>
      <AccountSection path='account/*'/>
    </Router>
  )
}

export {ReferenceSection}

export default ReferenceSection